import React, { useState, useEffect, useRef } from 'react'
import styles from './search.module.scss'

interface Props {
  q: string
  onSearch: (query: string) => void
}

const SearchInput = ({ q, onSearch }: Props) => {
  const inputRef = useRef<HTMLInputElement | null>(null)
  const timeout = useRef<NodeJS.Timeout | null>(null)
  const [ query, setQuery ] = useState(q || '')

  const onChange = (e) => {
    const searchQuery = e.target.value
    setQuery(searchQuery)
    clearTimeout(timeout.current)
    timeout.current = setTimeout(() => onSearch(searchQuery), 1000)
  }

  const onSubmit = (e) => {
    e.preventDefault()
    clearTimeout(timeout.current)
    onSearch(query)
  }

  useEffect(() => {
    inputRef.current.focus()
    return () => {
      clearTimeout(timeout.current)
    }
  }, [])

  useEffect(() => {
    setQuery(q)
  }, [ q ])

  return (
    <header className={styles.header}>
      <form className={styles.form} onSubmit={onSubmit}>
        <input
          ref={inputRef}
          className={styles.input}
          type="search"
          value={query}
          onChange={onChange}
          placeholder="Search on SOUND ON LIVE"
        />
      </form>
    </header>
  )
}

export default SearchInput
